import{
  LoaderWrap,
  CommonLoader
} from "./SimpleLoaderStyle";  

const SimpleLoader = () => {
  return (
    <LoaderWrap>
      <CommonLoader className='loading'></CommonLoader>
   </LoaderWrap>
  )
}

export default SimpleLoader
 